import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useTranslation } from "../context/TranslationContext";
import { useWebSocket } from '../context/WebSocketContext';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from "react-router-dom";
import { useNotification } from '../context/NotificationContext';
import { ConnectionEventEmitter } from '../utils/ConnectionEventEmitter';
import log from "loglevel";

import {
  validateEmail,
  validatePhone,
  validateEnterPassword,
  validateCreatePassword,
  validateName,
  validateCode
} from "../utils/Validation";

import Button from '../components/Button';
import Input from '../components/Input';
import InputVerificationCode from '../components/InputVerificationCode';
import Checkbox from '../components/Checkbox';
import PanelMain from '../components/PanelMain';
import PanelHorizontal from '../components/PanelHorizontal';
import PanelVertical from '../components/PanelVertical';
import PhoneInput from 'react-phone-input-2';


function Profile() {
  const { t } = useTranslation();
  const { showNotification } = useNotification();
  const { sendMessage, isConnected } = useWebSocket();
  const { logout, close } = useAuth();
 
  const navigate = useNavigate();

  const [state, setState] = useState('main');
  const [timer, setTimer] = useState(null);
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [termsAgree, setTermsAgree] = useState(true);
  const [rememberMe, setRememberMe] = useState(true);
  const [loginType, setLoginType] = useState('');
  const [enterPassword, setEnterPassword] = useState('');
  const [createPassword, setCreatePassword] = useState('');
  const [createReenterPassword, setCreateReenterPassword] = useState('');
  const [buttonStatus, setButtonStatus] = useState('inactive');
  const [verificationCode, setVerificationCode] = useState('');
  const [verifyPossible, setVerifyPossible] = useState(true);
  const [verifyPossibleDate, setVerifyPossibleDate] = useState('');
  const [createPasswordText, setCreatePasswordText] = useState('');
  const [createReenterPasswordText, setCreateReenterPasswordText] = useState('');
  const [userName, setUserName] = useState('');
  const [userSurname, setUserSurname] = useState('');

  const inputRefs = {
    enterEmail: useRef(null),
    enterPhone: useRef(null),
    enterPassword: useRef(null),
    createPassword: useRef(null),
    createReenterPassword: useRef(null),
    enterName: useRef(null),
    surname: useRef(null),
    terms: useRef(null),
    forgotSendEmail: useRef(null)
  };

  const handleInputChange = (value, setValue, validator) => {
    if(buttonStatus!=="loading") {
      if(setValue!==null) setValue(value);
      setButtonStatus(validator(value) ? "priority" : "inactive");
    }
  };

  const handleCreatePasswordChange = (value1, value2) => {
    if(buttonStatus!=="loading") {
      setCreatePassword(value1);
      setCreateReenterPassword(value2);
      let r = validateCreatePassword(value1,value2,t.general.CreatePasswordCheck);
      setCreatePasswordText(r.txt);
      if(r.pass) {
        setButtonStatus("priority");
        setCreateReenterPasswordText("");
      } else {
        setButtonStatus("inactive");
        setCreateReenterPasswordText(t.general.CreatePasswordMustMatch);
      }
    }
  };

  const handleNameChange = (name,surname,agree) => {
    if(buttonStatus!=="loading") {
      setUserName(name);
      setUserSurname(surname);
      setTermsAgree(agree);
      if(validateName(name,surname)&&agree===true) {
        setButtonStatus("priority");
      } else {
        setButtonStatus("inactive");
      }
    }
  };

  const action = (type) => {
    switch (type) {
      case 'logout':
        logout();
        break;
      case 'close':
        close();
        break;
    }
  };

  const refreshFocus = (state) => {
    log.debug("refreshFocus state: "+state);
    setTimeout(() => {
      const ref = inputRefs[state];
      if (ref && ref.current) {
        ref.current.focus();
      }
    }, 100); 
  };

  useEffect(() => {
    const stateHandlers = {
      main: () => {
      }
    };
    const handler = stateHandlers[state];
    if (handler) handler();

    refreshFocus(state);
  }, [state]);

  const connectionOpened = useCallback(() => {
    log.debug('Profile connectionOpened');
  }, []);

  const connectionClosed = useCallback(() => {
    log.debug('Profile connectionClosed');
  }, []);

  const emailRef = useRef(email);
  const phoneRef = useRef(phone);

  useEffect(() => {
    emailRef.current = email;
  }, [email]);
  
  useEffect(() => {
    phoneRef.current = phone;
  }, [phone]);

  const connectionReceived = useCallback((receivedMessage) => {
    if(receivedMessage) {
      log.debug('Received message:', receivedMessage);

      if(receivedMessage.area==='user') {
        switch (receivedMessage.command) {
          case 'logout':
            if(receivedMessage.status==='ok') {
            } 
            break;
          case 'close':
            if(receivedMessage.status==='ok') {
            } 
            break;
        }
      }
    }
  }, []);

  useEffect(() => {    
    ConnectionEventEmitter.on('opened', connectionOpened);
    ConnectionEventEmitter.on('closed', connectionClosed);
    ConnectionEventEmitter.on('received', connectionReceived);
    return () => { 
      if(timer) {
        clearTimeout(timer);
      }
      ConnectionEventEmitter.off('opened', connectionOpened);
      ConnectionEventEmitter.off('closed', connectionClosed);
      ConnectionEventEmitter.off('received', connectionReceived);
    }
  }, []);

  const contentMap = {
    main: (
      <div style={{height: "calc( 100% - var(--bottom-panel-height) ); display: flex; justify-content: center" }}>
        <PanelVertical height="calc(var(--button-height) * 2 + var(--margin-normal) * 3 + var(--font-normal) )">
          <Button type="active" onClick={() => action("close")}>{t.general.CloseAccount}</Button>
          <Button type="active" onClick={() => action("logout")}>{t.general.Logout}</Button>
        </PanelVertical>
      </div>
    ),
    otherState: <div>Wrong state!</div>,
  };

  return (
    <PanelMain className="panel-main-login">
      {(contentMap[state])}
    </PanelMain>
  );
}

export default Profile;